

import type { TravelerProfile } from '../../../types/travelerProfile';
import type { Action } from '../../types';
import { types as actionTypes } from './travelerProfileActions';

export type TravelerProfileState = {
  travelerProfile?: TravelerProfile,
};

const initialState: TravelerProfileState = {};

export default function reducer(
  state: TravelerProfileState = initialState,
  action: Action<TravelerProfile>,
) {
  switch (action.type) {
    case actionTypes.FETCH_SUCCESS:
      return {
        travelerProfile: action.response,
      };
    default:
      return state;
  }
}
